import { keyframes } from '@emotion/react';
const animateRing = keyframes({
  '0%, 20%, 80%, 100%': {
    transform: 'scale(1)'
  },
  '50%': {
    transform: 'scale(1.5)'
  }
});
export default {
  loadingContainer: {
    position: 'absolute',
    left: '50%',
    top: '50%'
  },
  loading: (color: string) => ({
    display: 'flex',
    position: 'relative',
    left: '-50%',
    width: '80px',
    height: '100%',
    margin: 'auto',
    alignItems: 'center',
    justifyContent: 'center',
    div: {
      position: 'absolute',
      width: ' 6px',
      height: '6px',
      background: color,
      borderRadius: '50%',
      animation: `${animateRing} 1.2s linear infinite`,
      '&:nth-of-type(1)': {
        animationDelay: '0s',
        top: '37px',
        left: '66px'
      },
      '&:nth-of-type(2)': {
        animationDelay: '-0.1s',
        top: '22px',
        left: '62px'
      },
      '&:nth-of-type(3)': {
        animationDelay: '-0.2s',
        top: '11px',
        left: '52px'
      },
      '&:nth-of-type(4)': {
        animationDelay: '-0.3s',
        top: '7px',
        left: '37px'
      },
      '&:nth-of-type(5)': {
        animationDelay: '-0.4s',
        top: '11px',
        left: '22px'
      },
      '&:nth-of-type(6)': {
        animationDelay: '-0.5s',
        top: '22px',
        left: '11px'
      },
      '&:nth-of-type(7)': {
        animationDelay: '-0.6s',
        top: '37px',
        left: '7px'
      },
      '&:nth-of-type(8)': {
        animationDelay: '-0.7s',
        top: '52px',
        left: '11px'
      },
      '&:nth-of-type(9)': {
        animationDelay: '-0.8s',
        top: '62px',
        left: '22px'
      },
      '&:nth-of-type(10)': {
        animationDelay: '-0.9s',
        top: '66px',
        left: '37px'
      },
      '&:nth-of-type(11)': {
        animationDelay: '-1s',
        top: '62px',
        left: '52px'
      },
      '&:nth-of-type(12)': {
        animationDelay: '-1.1s',
        top: '52px',
        left: '62px'
      }
    }
  })
};